/** Input and task boundaries shared by the mentor review workflow. */
import { isAudioUploadFile } from './audioUploadFormats';

export function parseMentorHours(value: string): number | null {
  const normalized = value.trim().replace(',', '.');
  if (!/^\d+(?:\.\d+)?$/.test(normalized)) return null;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

export function sessionFileKind(name: string): 'audio' | 'document' | null {
  if (isAudioUploadFile(name)) return 'audio';
  const extension = name.split('.').pop()?.toLowerCase();
  if (['pdf', 'txt', 'docx'].includes(extension || '')) return 'document';
  return null;
}

export function taskOutcome(status: string): 'complete' | 'failed' | 'pending' {
  if (['SUCCESS', 'COMPLETED'].includes(status.toUpperCase())) return 'complete';
  if (['FAILURE', 'FAILED', 'REVOKED'].includes(status.toUpperCase())) return 'failed';
  return 'pending';
}
